import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FilterList } from '@mui/icons-material';
import { Badge, Box, Fab, Grid, Typography } from '@mui/material';
import { AuthContext } from 'contexts/AuthContext';
import { DropsContext } from 'contexts/DropsContext';
import { DashboardContext } from 'contexts/DashboardContext';
import { useDrawer } from 'components/Modals';
import Container from 'components/Container';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Loader from 'components/Loader';
import Card from 'components/Card';
import Pie from './Charts/Pie';
import Bar from './Charts/Bar';
import styles from './styles';
import moment from 'moment';

const App = () => {
  const [count, setCount] = useState(0);
  const { user } = useContext(AuthContext);
  const { drops } = useContext(DropsContext);
  const { dashData, getLoading, getDashboard } = useContext(DashboardContext);
  const { openDrawer, closeDrawer } = useDrawer();
  const defaultValues = {
    tecnico_id: user?.nivel === 'TECNICO' ? [user?.id] : [],
    dti: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    dtf: null,
  };
  const { control, handleSubmit } = useForm({ defaultValues });
  const gridProps = { ...styles?.grid, item: true, md: 12 };

  const loadData = (params) => {
    closeDrawer();
    const countFilters = Object.values(params).reduce((acc, val) => {
      if (val == null) return acc;
      if (Array.isArray(val) && val.length === 0) return acc;
      if (typeof val === 'string' && val.trim() === '') return acc;
      return acc + 1;
    }, 0);
    setCount(countFilters);
    getDashboard({ params });
  };

  useEffect(() => {
    handleSubmit(loadData)();
  }, []);

  const FilterDrawer = () => {
    return (
      <Box m="1em">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Dropdown
              name="tecnico_id"
              control={control}
              label="Técnico"
              options={drops?.Users}
              multiple
              disabled={user?.nivel === 'TECNICO'}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              name="dti"
              control={control}
              label="Data de Emissão Inicial"
              type="date"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              name="dtf"
              control={control}
              label="Data de Emissão Final"
              type="date"
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(loadData)}
            >
              FILTRAR
            </Button>
          </Grid>
        </Grid>
      </Box>
    );
  };

  return (
    <Container>
      {getLoading && <Loader />}
      <Grid container spacing={5} display={getLoading ? 'none' : 'flex'}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4">Orçamentos</Typography>
            </Grid>
            <Grid {...gridProps} lg={4}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Card title="Orçamentos por status" style={styles?.card}>
                    <Pie values={dashData?.orcamento?.por_status} />
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card
                    title="Orçamentos aprovados / reprovados"
                    style={styles?.card}
                  >
                    <Pie values={dashData?.orcamento?.por_aprovacao} />
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid {...gridProps} lg={8}>
              <Card title="Orçamentos por técnico" style={styles?.card}>
                <Bar values={dashData?.orcamento?.por_tecnico} type="ORC" />
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4">Serviços</Typography>
            </Grid>
            <Grid {...gridProps} lg={4}>
              <Card title="Serviço por status" style={styles?.card}>
                <Pie values={dashData?.ordem?.por_status} />
              </Card>
            </Grid>
            <Grid {...gridProps} lg={8}>
              <Card title="Serviço por técnico" style={styles?.card}>
                <Bar values={dashData?.ordem?.por_tecnico} type="OS" />
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={styles?.fabContainer}>
        <Badge
          max={99}
          color="secondary"
          overlap="circular"
          badgeContent={count}
        >
          <Fab
            color="primary"
            onClick={() => openDrawer(<FilterDrawer />, 'Filtros')}
            sx={styles?.badge}
            disabled={getLoading}
          >
            <FilterList />
          </Fab>
        </Badge>
      </Box>
    </Container>
  );
};

export default App;
